export default __webpack_public_path__ + "static/media/fld_bi_gray.c1975588.svg";